import type { NumericGroupingMode } from '../utils/columnAlignment';

/**
 * PP-01 — the three `NumericGroupingMode` choices with their user-facing
 * labels, in display order. ONE list feeds the Settings → UI row
 * (`NumericGroupingSection`) and the cell context-menu submenu both grids
 * share (`NumericGroupingMenu`), so the copy can't drift between surfaces.
 * The example numbers show the exact separators each mode renders.
 */
export const NUMERIC_GROUPING_OPTIONS: ReadonlyArray<{ mode: NumericGroupingMode; label: string }> = [
  { mode: 'locale', label: 'Locale (1,234,567)' },
  { mode: 'thin-space', label: 'Thin space (1 234 567)' },
  { mode: 'off', label: 'Off (1234567)' },
];
